import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getPaymentUIDForAutopay(
  policyId,
  cardHolderName,
  userId,
  blockCode,
  zipCode,
  portalReturnURL
) {
  let url =
    config.REG_API_BASE_URL +
    "/Payment/uid?PolicyId=" +
    policyId +
    "&CardHolderName=" +
    cardHolderName +
    "&UserId=" +
    userId +
    "&BlockCode=" +
    blockCode +
    "&ZipCode=" +
    zipCode +
    "&PortalReturnURL=" +
    portalReturnURL;
  const response = await fetch(url, {
    headers: {
      Authorization: `bearer ${getToken()}`,
    },
  });
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
